import { AppearanceThemeId } from '../types/account-action-catalog-enums';

export const SIGN_OUT_LABEL = 'Sign out';
export const GET_STARTED_PATH = '/get-started';
export const GET_STARTED_LABEL = 'Get started';

export const APPEARANCE_THEME_OPTIONS = [
  { id: AppearanceThemeId.LIGHT, label: 'Light' },
  { id: AppearanceThemeId.DARK, label: 'Dark' },
  { id: AppearanceThemeId.SYSTEM, label: 'System' },
] as const;
